<!-- <div class="login-container">
    <mat-card>
      <mat-card-title>Biling</mat-card-title>
      
      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput formControlName="email" placeholder="Enter your email" />
        
          </mat-form-field>
  
          <mat-form-field appearance="fill" class="full-width">
            <mat-label>Password</mat-label>
            <input matInput formControlName="password" type="password" placeholder="Enter your password" />
       
          </mat-form-field>
  
  
  
          <div class="actions">
            <button class="btn btn-outline-green"  type="submit" [disabled]="isLoading">
              {{ isLoading ? 'Logging in...' : 'Login' }}
            </button>
          </div>
        </form>
      </mat-card-content>
    </mat-card>
  </div> -->

  <!-- <lbn-container title="Billing Information" subTitle="Company Details">
  <form [formGroup]="billingForm" (ngSubmit)="onSubmit()" class="form-content">

    <app-lbn-input-field
      label="Company Name"
      formControlName="companyName"
      placeholder="Enter company name">
    </app-lbn-input-field>

    <app-lbn-input-field
      label="Previous Name"
      formControlName="previouseName"
      placeholder="Enter previous name">
    </app-lbn-input-field>

    <app-lbn-input-field
      label="Company Registration"
      formControlName="companyRegistration"
      placeholder="Enter registration number">
    </app-lbn-input-field>

    <app-lbn-input-field
      label="Client Name"
      formControlName="clientName"
      placeholder="Enter client name">
    </app-lbn-input-field>

    <app-lbn-input-field
      label="Salesperson"
      formControlName="salesperson"
      placeholder="Enter salesperson name">
    </app-lbn-input-field>

    <app-lbn-input-field
      label="Administrator"
      formControlName="administrator"
      placeholder="Enter administrator name">
    </app-lbn-input-field>

    <div class="actions">
      <button mat-raised-button color="primary" type="submit" [disabled]="isLoading">
        {{ isLoading ? 'Saving...' : 'Submit' }}
      </button>
    </div>
  </form>
</lbn-container> -->

<!-- <div class="login-container">
  <mat-card>
    <mat-card-title>Billing</mat-card-title>
    
    <mat-card-content>
      <form [formGroup]="billingForm" (ngSubmit)="onSubmit()">
        
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Company Name</mat-label>
          <input matInput formControlName="companyName" placeholder="Enter company name" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Previous Name</mat-label>
          <input matInput formControlName="previouseName" placeholder="Enter previous name" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Company Registration</mat-label>
          <input matInput formControlName="companyRegistration" placeholder="Enter registration number" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Client Name</mat-label>
          <input matInput formControlName="clientName" placeholder="Enter client name" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Salesperson</mat-label>
          <input matInput formControlName="salesperson" placeholder="Enter salesperson name" />
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Administrator</mat-label>
          <input matInput formControlName="administrator" placeholder="Enter administrator name" />
        </mat-form-field>
         <app-data-picker
          [form]="billingForm"
          controlName="registrationDate"
          label="Registration Date">
        </app-data-picker>
        
         <app-input-dropdown
    [label]="'Category'"
    [formGroup]="billingForm"
    controlName="category"
    [options]="categories"
    (selectionChange)="onCategorySelect($event)"
  ></app-input-dropdown>

        <div class="actions">
          <button class="btn btn-outline-green" type="submit" [disabled]="isLoading">
            {{ isLoading ? 'Saving...' : 'Submit' }}
          </button>
        </div>

      </form>
    </mat-card-content>
  </mat-card>
</div> -->


<!-- <div class="page-container"> -->
 

  <!-- <mat-card appearance="outlined" class="lbn-container"> -->
   

      <mat-card-title>Billing & Licencing</mat-card-title>

      <form [formGroup]="billingForm" (ngSubmit)="onSubmit()" class="billing-form">
   
        <hr />
        <!-- Section 1 -->
       <app-lbn-accordian heading="Licence Details" [isOpen]="false">

  <div class="form1-grid">
<app-input-dropdown
      [label]="'license Type'"
      [formGroup]="billingForm"
      controlName="category"
      [options]="licenseTypes"
      (selectionChange)="onCategorySelect($event)">
    </app-input-dropdown>

    
     

    <mat-form-field appearance="outline">
      <mat-label>Registration Date</mat-label>
      <input ControlName="registrationDate" matInput [matDatepicker]="picker1" />
      <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker #picker1></mat-datepicker>
    </mat-form-field>

    <app-lbn-input-field
      [formGroup]="billingForm"
      label="Company Name"
      ControlName="companyName"
      placeholder="Enter company name">
    </app-lbn-input-field>

    <app-lbn-input-field
      [formGroup]="billingForm"
      label="Company Code"
      ControlName="companyRegistration"
      placeholder="Enter company registration"   [disabled]="true">
    </app-lbn-input-field>

   

     <app-input-dropdown
      [label]="'Instance'"
      [formGroup]="billingForm"
      controlName="category"
      [options]="instanceslist"
      (selectionChange)="onCategorySelect($event)">
    </app-input-dropdown>

  
</div>
<app-checkboxes
      label=""
      [checkboxes]="isGroupCompanyOptions"
      (selectionChange)="ongroupCompanyChange($event)">
    </app-checkboxes>
    <!--  <mat-form-field appearance="outline">
      <mat-label>Joining Date</mat-label>
      <input ControlName="joiningDate" matInput [matDatepicker]="picker2" />
      <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
      <mat-datepicker #picker2></mat-datepicker>
    </mat-form-field> 
    <app-checkboxes
      label=""
      [checkboxes]="isGroupCompanyOptions"
      (selectionChange)="ongroupCompanyChange($event)">
    </app-checkboxes> -->
<!-- 
    <app-input-dropdown
      [label]="''"
      [formGroup]="billingForm"
      controlName="category"
      [options]="categories"
      (selectionChange)="onCategorySelect($event)">
    </app-input-dropdown> -->

  
</app-lbn-accordian>


        <hr />
     
         
              <!-- Section 3 -->
        <app-lbn-accordian heading="Relationship" [isOpen]="false">
     

          <app-checkboxes
            label="Relationship"
            [checkboxes]="relationshipOptions"
            (selectionChange)="onRelationshipSelectionChange($event)">
          </app-checkboxes>
        </app-lbn-accordian>

        <hr />
              <!-- Section 4 -->
        <app-lbn-accordian heading="Client Details" [isOpen]="false">
       
          <!-- <app-radio-buttons
            label="Client Owner"
            [buttons]="clientOwnerButtons"
            (selectionChange)="onClientOwnerChange($event)">
          </app-radio-buttons> -->
<div class="form-grid">
          <app-input-dropdown
            [label]="'Client Type'"
            [formGroup]="billingForm"
            controlName="clientType"
            [options]="clienttypes"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>

            <app-input-dropdown
            [label]="'Service Type'"
            [formGroup]="billingForm"
            controlName="serviceType"
            [options]="servicetypes"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>
            <app-input-dropdown
            [label]="'Region'"
            [formGroup]="billingForm"
            controlName="region"
            [options]="regions"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>
            <app-input-dropdown
            [label]="'Branch'"
            [formGroup]="billingForm"
            controlName="branch"
            [options]="branches"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>
   <mat-form-field class="lbn-input" appearance="outline">
          <mat-label>Deactivation Date</mat-label>
          <input ControlName="deactivationDate" matInput [matDatepicker]="picker7" />
          <mat-datepicker-toggle matIconSuffix [for]="picker7"></mat-datepicker-toggle>
         
            <mat-datepicker #picker7></mat-datepicker>
        </mat-form-field>
          <app-input-dropdown
            [label]="'Deactivation Reason'"
            [formGroup]="billingForm"
            controlName="deactivationReason"
            [options]="deactivationreasons"
            (selectionChange)="onCategorySelect($event)">

          </app-input-dropdown>
          
          

          

           
            <app-lbn-input-field
            [formGroup]="billingForm"
            label="Salesperson"
            ControlName="salesperson"
            placeholder="Enter Salesperson Name"> 
          </app-lbn-input-field>
            <!-- <app-lbn-input-field
            [formGroup]="billingForm"
            label="Administrator"
            ControlName="administrator"
            placeholder="Enter Administrator Name">
          </app-lbn-input-field> -->
            <app-lbn-input-field
            [formGroup]="billingForm"
            label="CRE"
            ControlName="cre"
            placeholder="Enter CRE">
          </app-lbn-input-field>
    </div>       
<!-- <mat-form-field appearance="outline" class="lbn-input">
  <mat-label>Comments</mat-label>
  <textarea matInput formControlName="comments" placeholder="Enter Comments"></textarea>
</mat-form-field> -->


        </app-lbn-accordian>

      

        <hr />
               <!-- Section 5 -->
        <!-- <app-lbn-accordian heading="Communication Types" [isOpen]="false">
     

       

          <app-checkboxes
            label=""
            [checkboxes]="noticeOptions"
            (selectionChange)="onCheckboxSelectionChange($event)">
          </app-checkboxes>
        </app-lbn-accordian>

        <hr /> -->
                      <!-- Section 6 -->
       
     


<!-- <mat-tab-group [(selectedIndex)]="selectedTabIndex"  mat-stretch-tabs="false" mat-align-tabs="start">
   <mat-tab label="Licence Info "> </mat-tab> 
   <mat-tab label="Contact Info"> </mat-tab> 
   <mat-tab label="Payment/Billing Info"> </mat-tab>
   </mat-tab-group> -->

                <!-- Licence Info Accordion -->
<app-lbn-accordian  heading="Licence Info" [isOpen]="false">
<table mat-table [dataSource]="selectedProducts" class="mat-elevation-z8" style="width: 100%;">

  <!-- Product Column -->
  <ng-container matColumnDef="product">
    <th mat-header-cell *matHeaderCellDef> Product </th>
    <td mat-cell *matCellDef="let element"> {{ element.product?.name }} </td>
  </ng-container>

  <!-- Expiry Date Column -->
  <ng-container matColumnDef="expiryDate">
    <th mat-header-cell *matHeaderCellDef> Expiry Date </th>
    <td mat-cell *matCellDef="let element"> {{ element.expiryDate | date:'mediumDate' }} </td>
  </ng-container>

  <!-- Access Type Column -->
  <ng-container matColumnDef="accessTypes">
    <th mat-header-cell *matHeaderCellDef> Access Type </th>
    <td mat-cell *matCellDef="let element"> {{ element.accessTypes }} </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<hr />
     <mat-form-field appearance="outline">
    <mat-label>Product</mat-label>
    <mat-select formControlName="product">
      <mat-option *ngFor="let p of productOption" [value]="p">
        {{ p.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
 <mat-form-field appearance="outline">
    <mat-label>Expiry Date</mat-label>
    <input matInput [matDatepicker]="picker9" formControlName="expiryDate">
    <mat-datepicker-toggle matSuffix [for]="picker9"></mat-datepicker-toggle>
    <mat-datepicker #picker9></mat-datepicker>
  </mat-form-field>
    <mat-form-field appearance="outline">
    <mat-label>Access Type</mat-label>
    <mat-select formControlName="accessTypes">
      <mat-option *ngFor="let type of accessTypeOptions" [value]="type">
        {{ type }}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- Add button aligned to the right with icon -->
<div class="button-container">
  <button mat-raised-button class="custom-add-button" (click)="addProduct()">
    <mat-icon>add</mat-icon>
    Add
  </button>
</div>



    <!-- Table of added products -->
<!-- 

          <app-checkboxes
            label=""
            [checkboxes]="expiryOptions"
            (selectionChange)="onExpirySelectionChange($event)">
          </app-checkboxes> -->
            <div class="labeled-line">
Maxium (PSiberWorks)
</div>
 
  <app-checkboxes
      label=""
      [checkboxes]="isunlimitedOptions"
      (selectionChange)="ongroupCompanyChange($event)">
    </app-checkboxes>
  <app-lbn-input-field
  [formGroup]="billingForm"
  label="Active Employees"
  controlName="activeEmployees"
  placeholder="Enter  Amount"
  inputType="numeric">
</app-lbn-input-field>
<app-checkboxes
      label=""
      [checkboxes]="isunlimitedOptions"
      (selectionChange)="ongroupCompanyChange($event)">
    </app-checkboxes>

  <app-lbn-input-field
  [formGroup]="billingForm"
  label="Total Employees"
  controlName="totalEmployees"
  placeholder="Enter  Amount"
  inputType="numeric">
</app-lbn-input-field>
<app-checkboxes
      label=""
      [checkboxes]="isunlimitedOptions"
      (selectionChange)="ongroupCompanyChange($event)">
    </app-checkboxes>
  <app-lbn-input-field
  [formGroup]="billingForm"
  label="Payslips Per Interval"
  controlName="payslipsPerInterval"
  placeholder="Enter  Amount"
  inputType="numeric">
</app-lbn-input-field>

</app-lbn-accordian>

<!-- Contact Info Accordion -->
<app-lbn-accordian *ngIf="selectedTabIndex === 1" heading="Contact Info" [isOpen]="true">
  <div class="form2-grid">
       <app-lbn-input-field
          [formGroup]="billingForm"
          label="Contact Email"
          ControlName="contactEmail"
          placeholder="Enter Contact Email">
        </app-lbn-input-field>

          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Contact Email(alternate)"
            ControlName="contactEmailOther"
            placeholder="Enter Contact Phone">    
          </app-lbn-input-field>

          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Telephone"
            ControlName="telephone"
            placeholder="Enter Telephone">
          </app-lbn-input-field>

          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Cellular"
            ControlName="cellular"
            placeholder="Enter Mobile">
          </app-lbn-input-field>  
</div>
  <div class="labeled-line">
  Physical Address
</div>
 <div class="form2-grid">
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Unit Number"
            ControlName="unitNumber"
            placeholder="Enter Unit Number">
          </app-lbn-input-field>

             <app-lbn-input-field
            [formGroup]="billingForm"
            label="Complex Name"
            ControlName="complexName"
            placeholder="Enter Complex Name">
          </app-lbn-input-field>
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Street Number"
            ControlName="streetNumber"
            placeholder="Enter Street Number">
          </app-lbn-input-field>


          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Street Address"
            ControlName="streetAddress"
            placeholder="Enter Street Address">
          </app-lbn-input-field>
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Suburb"
            ControlName="suburb"
            placeholder="Enter Suburb">
          </app-lbn-input-field>
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="City"
            ControlName="city"
            placeholder="Enter City">
          </app-lbn-input-field>
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="Province"
            ControlName="province"
            placeholder="Enter Province">
          </app-lbn-input-field>
        
       
  <app-lbn-input-field
            [formGroup]="billingForm"
            label="Zip Code"
            ControlName="zipCode"
            placeholder="Enter Zip Code">
          </app-lbn-input-field>
          </div>
 <div class="labeled-line">
  Postal Address
</div>
<div class="form-grid">
          <app-lbn-input-field
            [formGroup]="billingForm"
            label="line1"
            ControlName="line1"
            placeholder="Enter line1">
          </app-lbn-input-field>

     <app-lbn-input-field
            [formGroup]="billingForm"
            label="line2"
            ControlName="line2"
            placeholder="Enter line2">
          </app-lbn-input-field>
               <app-lbn-input-field
            [formGroup]="billingForm"
            label="line3"
            ControlName="line3"
            placeholder="Enter line">
          </app-lbn-input-field>


             <app-lbn-input-field
            [formGroup]="billingForm"
            label="Postal Code"
            ControlName="postalCode"
            placeholder="Enter Postal Code">
          </app-lbn-input-field>
             <app-lbn-input-field
            [formGroup]="billingForm"
            label="Country"
            ControlName="country"
            placeholder="Enter Country">
          </app-lbn-input-field>


</div>

</app-lbn-accordian>

<!-- Payment/Billing Info Accordion -->
<app-lbn-accordian *ngIf="selectedTabIndex === 2" heading="Payment/Billing Info" [isOpen]="true">
  <app-input-dropdown
            [label]="'Anniversary Month'"
            [formGroup]="billingForm"
            controlName="anniversaryMonth"
            [options]="anniversarymonths"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>

            <app-input-dropdown
            [label]="'Billing Type'"
            [formGroup]="billingForm"
            controlName="billingUsage"
            [options]="billingtypes"
            (selectionChange)="onCategorySelect($event)">
          </app-input-dropdown>
            <div class="labeled-line">
  Product Billing Amounts
</div>
 <div class="form1-grid">
          <app-lbn-input-field
  [formGroup]="billingForm"
  label="WORKS"
  controlName="works"
  placeholder="Enter  Amount"
  inputType="currency">
</app-lbn-input-field>
   
 

    <app-lbn-input-field
  [formGroup]="billingForm"
  label="PAY"
  controlName="pay"
  placeholder="Enter Works Amount"
  inputType="currency">
</app-lbn-input-field>
    <app-lbn-input-field
  [formGroup]="billingForm"
  label="HRA"
  controlName="hra"
  placeholder="Enter  Amount"
  inputType="currency">
</app-lbn-input-field>
   <app-lbn-input-field
  [formGroup]="billingForm"
  label="HRM"
  controlName="hrm"
  placeholder="Enter  Amount"
  inputType="currency">
</app-lbn-input-field>   <app-lbn-input-field
  [formGroup]="billingForm"
  label="ESS"
  controlName="ess"
  placeholder="Enter Amount"
  inputType="currency">
</app-lbn-input-field>

</div>
  <div class="labeled-line">
   Payment / Billing Notes
</div>
  <mat-form-field appearance="outline" class="lbn-input">
  <mat-label>Conversion</mat-label>
  <textarea matInput formControlName="conversion" placeholder="Enter Notes"></textarea>
</mat-form-field>
</app-lbn-accordian>

 



        <div class="padding-lr">
          <app-form-actions-buttons [buttons]="updateButtons"></app-form-actions-buttons>
        </div>
      </form>

   
  <!-- </mat-card> -->
<!-- </div> -->


